export default "__VITE_ASSET__9f5d1ec8__"